const SEQUENCE_REDUX_CONSTANT = {
    // Sequences list
    SET_SEQUENCES: 'SET_SEQUENCES',
    SET_LOADING_SEQUENCES: 'SET_LOADING_SEQUENCES',

    // Current sequence
    SET_CURRENT_SEQUENCE: 'SET_CURRENT_SEQUENCE',
    SET_LOADING_SEQUENCE: 'SET_LOADING_SEQUENCE',

    // Create/Update
    SET_CREATING_SEQUENCE: 'SET_CREATING_SEQUENCE',
    SET_UPDATING_SEQUENCE: 'SET_UPDATING_SEQUENCE',

    // Enrollment
    SET_ENROLLING: 'SET_ENROLLING',
    SET_ENROLLMENT_STATUS: 'SET_ENROLLMENT_STATUS',
    SET_SEQUENCE_ENROLLMENTS: 'SET_SEQUENCE_ENROLLMENTS',
    SET_LOADING_ENROLLMENTS: 'SET_LOADING_ENROLLMENTS',

    // Errors
    SET_SEQUENCE_ERROR: 'SET_SEQUENCE_ERROR',
    CLEAR_SEQUENCE_ERROR: 'CLEAR_SEQUENCE_ERROR',
};

export default SEQUENCE_REDUX_CONSTANT;
